// Imports for external libraries go here.
import clsx from 'clsx';
import { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { Button } from '@marriott/mi-ui-library';
import { NavigationDropdownProps } from '../NavigationDropdown.types';
import { StyledSubMenu, StyledSubMenuContainer, StyledSubMenuItem } from './NavigationDropdownMobile.styles';

const NavigationDropdownMobile: FC<NavigationDropdownProps> = ({
  menuItemLabel,
  ariaLabel,
  sectionNavigationSubItems,
  activeMenuItem,
  trackingProperties,
  menuItemIndex,
}) => {
  return (
    <StyledSubMenuContainer aria-label={ariaLabel} className="sub-menu-container">
      <StyledSubMenu>
        {sectionNavigationSubItems?.map((subMenuItem, subMenuItemIndex) => (
          <StyledSubMenuItem
            className={clsx(
              menuItemLabel === activeMenuItem?.menuLabel &&
                subMenuItem.subMenuItemLabel === activeMenuItem?.subMenuLabel &&
                'selected'
            )}
            key={`sub-menu-item-${menuItemIndex}${subMenuItemIndex}`}
            data-testid={`sub-menu-item-${menuItemIndex}${subMenuItemIndex}`}
          >
            <Button
              isLink={true}
              href={subMenuItem.subMenuItemPath}
              custom_click_track_value={`${menuItemLabel} | ${subMenuItem.subMenuItemLabel} |internal`}
              trackingProperties={trackingProperties}
              target={subMenuItem?.openInNewTab ? '_blank' : '_self'}
              ariaLabel={subMenuItem.subMenuItemLabel}
            >
              {subMenuItem.subMenuItemLabel}
            </Button>
          </StyledSubMenuItem>
        ))}
      </StyledSubMenu>
    </StyledSubMenuContainer>
  );
};

export default NavigationDropdownMobile;
